module.exports = __webpack_public_path__ + "img/foto2.3ca7e22d.webp";